import BaseService from "../../services/BaseService";
import TransactionCategoryService from "../../services/TransactionCategoryService";

export default {
    state: {
        transactionCategories: [],
        transactionTreeViewCategories: [],
    },
    getters: {
        transactionCategories: state => {
            return state.transactionCategories;
        },
        transactionTreeViewCategories: state => {
            return state.transactionTreeViewCategories;
        },
    },
    mutations: {
        SET_TRANSACTION_CATEGORIES(state, transactionCategories) {
            state.transactionCategories = transactionCategories;
        },
        SET_TRANSACTION_TREE_VIEW_CATEGORIES(state, transactionTreeViewCategories) {
            state.transactionTreeViewCategories = transactionTreeViewCategories;
        },
    },
    actions: {
        loadTransactionCategories( { state, commit, dispatch }, force = false) {
            if (force || !state.transactionCategories.length) {
                TransactionCategoryService.index().then((result) => {
                    if (result.status === BaseService.STATUS_200) {
                        commit('SET_TRANSACTION_CATEGORIES', result.data);
                        dispatch('loadTransactionTreeViewCategories', true);
                    }
                });
            }
        },
        loadTransactionTreeViewCategories( { state, commit }, force = false) {
            if (force || !state.transactionTreeViewCategories.length) {
                TransactionCategoryService.treeViewItems().then((result) => {
                    if (result.status === BaseService.STATUS_200) {
                        commit('SET_TRANSACTION_TREE_VIEW_CATEGORIES', result.data);
                    }
                });
            }
        },
        createTransactionCategory( { dispatch }, data) {
            return TransactionCategoryService.createTransactionCategory(data).then((result) => {
                if (result.status === BaseService.STATUS_200) {
                    dispatch('loadTransactionCategories', true);
                }
            });
        },
        updateTransactionCategory( { dispatch }, params) {
            return TransactionCategoryService.updateTransactionCategory(params.id, params.data).then((result) => {
                if (result.status === BaseService.STATUS_200) {
                    dispatch('loadTransactionCategories', true);
                }
            });
        },
        deleteTransactionCategory( { dispatch }, id) {
            return TransactionCategoryService.deleteTransactionCategory(id).then((result) => {
                if (result.status === BaseService.STATUS_200) {
                    dispatch('loadTransactionCategories', true);
                }
            });
        }
    },
}